import { FallbackError } from "@core/domain/errors/fallback.error";
import type { ModelError } from "@iot-platform/core";
import { WeatherDatasource } from "@weather/data/datasources/weather.datasource";
import type { WeatherNoCoordsError } from "@weather/domain/errors/weather-no-coords.error";
import type { Weather } from "@weather/domain/models/weather.model";
import type { WeatherRepository } from "@weather/domain/repositories/weather.repository";
import { inject, injectable } from "inversify";
import type { ResultAsync } from "neverthrow";

@injectable()
export class WeatherImplRepository implements WeatherRepository {
    constructor(
        @inject(WeatherDatasource)
        private readonly weatherDatasource: WeatherDatasource,
    ) {}

    getAll(
        stationId: string,
    ): ResultAsync<
        Weather,
        ModelError<typeof Weather> | WeatherNoCoordsError | FallbackError
    > {
        return this.weatherDatasource.fetchAll(stationId);
    }
}
